<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <div>
      <!-- Loader -->
      <v-skeleton-loader v-if="loading" class="ma-3 pa-2" v-bind="attrs"
        type="list-item-three-line"></v-skeleton-loader>

      <!-- Main Card -->
      <div v-else>
        <v-card>
          <v-card-title>
            Print I card
          </v-card-title>
          <v-card-text>
            <v-row class="ma-2" justify="center">
              <v-col cols="12" sm="3">
                <v-select v-model="selected_template" :items="template_list" outlined item-text="template_name"
                  item-value="id">
                  <template v-slot:label>
                    Template<span style="color:red;font-size:20px">*</span>
                  </template>
                </v-select>
              </v-col>
            </v-row>

            <v-row class="ma-2 justify-center">
              <v-radio-group v-model="is_instructor" row>
                <v-radio label="Student" :value="false"></v-radio>
                <v-radio label="Faculty" :value="true"></v-radio>
              </v-radio-group>
            </v-row>

            <!-- Student Section -->
            <div v-if="!is_instructor">
              <v-row class="ma-2" justify="center">
                <v-col cols="12" sm="2" md="2">
                  <v-select v-model="selected_ay" :items="ay_list" item-text="ay" item-value="id" label="Academic Year"
                    outlined @change="getDivisionList()"></v-select>
                </v-col>
                <v-col cols="12" sm="2" md="2">
                  <v-select v-model="selected_standard" :items="standard_list" item-text="name" item-value="id"
                    label="Standard" outlined @change="getDivisionList()"></v-select>
                </v-col>
                <v-col cols="12" sm="2" md="2">
                  <v-select v-model="selected_divison" :items="division_list" item-text="name" item-value="id"
                    label="Division" outlined></v-select>
                </v-col>
                <v-col cols="12" sm="3" md="3">
                  <v-select v-model="selected_principal" :items="principal_list" item-text="name" item-value="id"
                    label="Principal" outlined></v-select>
                </v-col>
                <v-col cols="12" sm="2" md="2">
                  <v-select v-model="selected_status" :items="status_list" item-text="name" item-value="id"
                    label="Status" outlined></v-select>
                </v-col>
              </v-row>

              <center>
                <span>
                  <hr style="width: 10%;" />OR
                  <hr style="width: 10%;" />
                </span>
              </center>

              <v-row class="ma-2 justify-center">
                <v-col cols="12" sm="6">
                  <v-textarea outlined v-model="prn_input" label="Enter RRN(s) (comma or newline separated)" auto-grow
                    rows="3"></v-textarea>
                </v-col>
              </v-row>
            </div>

            <!-- Faculty Section -->
            <div v-else>
              <v-row class="ma-2" justify="center">
                <v-col cols="12" sm="3" md="3">
                  <v-icon color="error">*</v-icon>
                  <v-autocomplete required @change="getInst()" v-model="emp_type" :items="emp_type_list"
                    item-text="name" item-value="id" label="Employee Type" outlined dense>
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" sm="3" md="3">
                  <v-icon color="error">*</v-icon>
                  <v-autocomplete v-model="sel_emp" :items="inst_list" item-text="name" item-value="id"
                    label="Employees" multiple chips outlined dense>

                    <template v-slot:selection="{ item, index }">
                      <v-chip v-if="index === 0">
                        <span>{{ item.name }}</span>
                      </v-chip>
                      <span v-if="index === 1" class="grey--text text-caption">
                        (+{{ sel_emp.length - 1 }} others)
                      </span>
                    </template>

                    <template v-slot:prepend-item>
                      <v-list-item @mousedown.prevent>
                        <v-list-item-action>
                          <v-checkbox v-model="selected_all_employees" @change="toggle_employee">
                            <template #label>
                              <span class="ml-8">Select All</span>
                            </template>
                          </v-checkbox>
                        </v-list-item-action>
                      </v-list-item>
                      <v-divider class="mt-2"></v-divider>
                    </template>

                  </v-autocomplete>
                </v-col>
              </v-row>

              <center>
                <span>
                  <hr style="width: 10%;" />OR
                  <hr style="width: 10%;" />
                </span>
              </center>

              <v-row class="ma-2 justify-center">
                <v-col cols="12" sm="6">
                  <v-textarea outlined v-model="employee_code_input"
                    label="Enter Employee Code(s) (comma or newline separated)" auto-grow rows="3"></v-textarea>
                </v-col>
              </v-row>
            </div>

            <v-row>
              <v-col cols="12" sm="12">
                <center>
                  <v-btn :loading="fetch_loading" color="primary" @click="getBatchIDCards">
                    Fetch
                  </v-btn>
                </center>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </div>

      <!-- Print Button -->
      <v-row v-if="Array.isArray(student_list) && student_list.length > 0" class="mt-3">
        <div class="ma-1">
          <v-btn color="primary" @click="printIDCard">Print All</v-btn>
        </div>
      </v-row>

      <!-- Preview IFrame -->
      <div style="margin-top:10px;">
        <iframe ref="previewFrame" style="width:100%;height:1000px;border:none;"></iframe>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {

  data() {
    return {
      selected_template: "",
      template_list: [],
      prn_input: "",
      loading: false,
      fetch_loading: false,

      idcard_html: "",
      idcard_object: null,
      lastStudent: null,

      division_list: [],
      selected_divison: "",
      standard_list: [],
      selected_standard: "",
      ay_list: [],
      selected_ay: "",
      is_instructor: false,
      employee_code_input: "",
      emp_type_list: [],
      student_list: [],
      issue_loader: false,
      snackbar_msg: "",
      color: "",
      snackbar: false,
      selected_status: 0,
      status_list: [{ name: 'Active', id: 0 }, { name: 'Temporary Inactive', id: 1 }, { name: 'Permanently Inactive', id: 2 }],
      principal_list: [],
      selected_principal: null,
      emp_type: null,
      sel_emp: [],
      inst_list: [],
      selected_all_employees: false,
    };
  },

  mounted() {
    this.init();
    this.getPrincipalList();
  },

  methods: {
    getInst() {
      if (this.emp_type == "") {
        return;
      }
      (this.inst = null), (this.inst_list = null);
      const data = {
        emp_type: this.emp_type,
      };
      axios
        .post("/Communication/getEmployees", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.inst_list = res.data.instructor_list.filter(item => item.id !== null);
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
        })
        .catch((error) => {
          this.onerror(error);
        })
        .finally(() => { });
    },
    toggle_employee() {
      this.$nextTick().then(() => {
        if (this.selected_all_employees) {
          this.sel_emp = [];
          for (var x in this.inst_list) {
            this.sel_emp.push(this.inst_list[x].id);
          }
        } else {
          this.sel_emp = [];
        }
      });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    getPrincipalList() {
      axios
        .post("Certificate/getPrincipalList")
        .then((res) => {
          if (res.data.flag == "YES") {
            this.principal_list = res.data.principal_list;
          } else {
            this.showSnackbar("#b71c1c", res.data.status_reason);
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong!!!");
        })
        .finally(() => { });
    },

    getDivisionList() {
      if (!this.selected_ay || !this.selected_standard)
        return;
      this.selected_divison = "";
      var params = {
        selected_ay: this.selected_ay,
        selected_standard: this.selected_standard,
      };
      this.$nextTick(() => {
        this.program_type_list = true;
        axios.post("/IDCard/getDivisionList", params).then((res) => {
          this.program_type_list = false;
          if (res.data.msg === "200") {
            this.division_list = res.data.division_list;
            if (Array.isArray(this.division_list) && this.division_list.length > 0)
              this.selected_divison = this.division_list[0].id;
          } else {
            this.showSnackbar("red", res.data.msg);
            this.program_type_list = false;
          }
        });
      });
    },

    init() {
      this.loading = true;
      axios
        .post("/IDCard/getIdcardTemplateList")
        .then((res) => {
          this.loading = false;
          if (res.data.msg === "200") {
            this.template_list = res.data.template_list;
            this.ay_list = res.data.ay_list;
            this.sem_list = res.data.sem_list;
            this.emp_type_list = res.data.emp_type_list;
            this.standard_list = res.data.standard_list;
            if (Array.isArray(this.ay_list) && this.ay_list.length > 0)
              this.selected_ay = res.data.current_ay;
            if (Array.isArray(this.standard_list) && this.standard_list.length > 0) {
              // this.selected_standard = this.standard_list[0].id;
              this.getDivisionList();
            }
          } else {
            this.showSnackbar("red", res.data.msg);
          }
        })
        .catch((e) => {
          this.loading = false;
          console.error(e);
        });
    },

    resolveDynamicText(templateText, student, fallback) {
      if (templateText === undefined || templateText === null) return fallback != null ? fallback : "";
      return String(templateText).replace(/{{\s*([^}]+)\s*}}/g, function (m, key) {
        if (student && student[key] !== undefined && student[key] !== null) return student[key];
        var up = key.toUpperCase();
        if (student && student[up] !== undefined && student[up] !== null) return student[up];
        return fallback !== undefined && fallback !== null ? fallback : "";
      });
    },

    async getBatchIDCards() {
      if (!this.selected_template) {
        this.showSnackbar("red", "Please select a template");
        return;
      }
      var by_prn = false;
      var is_employee_code = false;
      var prnList;
      var employeeCodeList;

      if (!this.is_instructor) {
        if (!this.prn_input || !this.prn_input.trim()) {
          if (!this.selected_ay) {
            this.showSnackbar("red", "Please select Ay");
            return;
          }

          if (!this.selected_standard) {
            this.showSnackbar("red", "Please select Standard");
            return;
          }

          if (!this.selected_divison) {
            this.showSnackbar("red", "Please select a Division");
            return;
          }
        } else {
          by_prn = true;
          prnList = this.prn_input
            .split(/[\n,]+/)
            .map(function (v) { return v.trim(); })
            .filter(Boolean);
        }
      } else {
        if (this.sel_emp && this.sel_emp.length > 0) {
          is_employee_code = false;
        }

        else if (this.employee_code_input && this.employee_code_input.trim()) {
          is_employee_code = true;
          employeeCodeList = this.employee_code_input
            .split(/[\n,]+/)
            .map(function (v) {
              return v.trim();
            })
            .filter(Boolean);
        }
        else {
          this.showSnackbar(
            "red",
            "Please select Employee/s or enter Employee Code(s)"
          );
          return;
        }

      }

      this.fetch_loading = true;

      try {
        // 1) load template
        const templateRes = await axios.post("/IDCard/getIDCard", {
          id: this.selected_template,
        });
        if (!templateRes.data || templateRes.data.msg !== "200") {
          this.fetch_loading = false;
          this.showSnackbar("red", "Failed to load template");
          return;
        }
        const templateHTML = templateRes.data.template.template_html;
        this.idcard_object = JSON.parse(templateRes.data.template.template_json);

        console.log(templateHTML);
        console.log("---------------");
        console.log(this.idcard_object);

        // metadata sjf hsdf sdfsd
        var frontElements = (this.idcard_object.front && this.idcard_object.front.elements) ? this.idcard_object.front.elements : [];
        var backElements = (this.idcard_object.back && this.idcard_object.back.elements) ? this.idcard_object.back.elements : [];
        const allElements = frontElements.concat(backElements);

        // fetch ALL students in one call yash
        this.student_list = [];
        const stuRes = await axios.post("/IDCard/getDetailsForIDcard", {
          selected_prn: prnList ? prnList.join(",") : "",
          by_prn: by_prn,
          selected_ay: this.selected_ay,
          selected_standard: this.selected_standard,
          selected_status: this.selected_status,
          selected_divison: this.selected_divison,
          selected_principal: this.selected_principal,
          is_instructor: this.is_instructor,
          is_employee_code: is_employee_code,

          selected_employee_ids:
            (!is_employee_code && this.sel_emp && this.sel_emp.length > 0)
              ? this.sel_emp.join(",")
              : "",

          employee_code:
            is_employee_code && employeeCodeList
              ? employeeCodeList.join(",")
              : "",
        });
        if (!stuRes.data || (stuRes.data.msg !== "200" && stuRes.data.status !== "200")) {
          this.fetch_loading = false;
          this.showSnackbar("red", "Failed fetching student details");
          return;
        }

        const students = Array.isArray(stuRes.data.studentData) ? stuRes.data.studentData : [];
        this.student_list = students;
        let combinedHTML = "";

        // 3) build combined HTML for every student
        for (let sIndex = 0; sIndex < students.length; sIndex++) {
          const student = students[sIndex] || {};
          const prn = this.is_instructor
            ? (student.Employee_Code || (employeeCodeList && employeeCodeList[sIndex]) || ("prn_" + sIndex))
            : (student.PRN || (prnList && prnList[sIndex]) || ("prn_" + sIndex));
          this.lastStudent = student;

          // fresh copy of template HTML
          let html = templateHTML;

          // replace placeholders with student data
          html = html.replace(/{{\s*([^}]+)\s*}}/g, function (m, key) {
            var v = student[key];
            if (v !== undefined && v !== null) return v;
            var up = key.toUpperCase();
            if (student[up] !== undefined && student[up] !== null) return student[up];
            return "";
          });

          // parse the student's HTML
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, "text/html");

          doc.querySelectorAll("img[data-tag]").forEach(function (img) {
            const tag = img.getAttribute("data-tag");
            if (tag === "UserPhoto" && student.PHOTOURL) {
              img.setAttribute("src", student.PHOTOURL);
            } else if (tag === "StudentSign" && student.SIGNURL) {
              img.setAttribute("src", student.SIGNURL);
            } else if (tag === "FatherPhoto" && student.FATHER_PHOTO_URL) {
              img.setAttribute("src", student.FATHER_PHOTO_URL);
            } else if (tag === "MotherPhoto" && student.MOTHER_PHOTO_URL) {
              img.setAttribute("src", student.MOTHER_PHOTO_URL);
            } else if (tag === "PrincipalSign" && student.headMasterSign) {
              img.setAttribute("src", student.headMasterSign);
            } else if (tag === "EmployeePhoto" && student.employee_photo) {
              img.setAttribute("src", student.employee_photo);
            } else if (tag === "EmployeeSign" && student.employee_sign) {
              img.setAttribute("src", student.employee_sign);
            }
          });

          const pagesNodeList = doc.body.querySelectorAll(".page");
          const pages = pagesNodeList.length ? Array.from(pagesNodeList) : [doc.body];

          for (let pIndex = 0; pIndex < pages.length; pIndex++) {
            const page = pages[pIndex];

            var frontCard = (this.idcard_object.front && this.idcard_object.front.card)
              ? this.idcard_object.front.card
              : { width: 54, height: 86 };
            page.style.width = frontCard.width + "mm";
            page.style.height = frontCard.height + "mm";
            page.style.position = "relative";

            // process each svg barcode in this page
            var self = this;
            page.querySelectorAll("svg[id^='barcode-']").forEach(function (svg, svgIndex) {
              const originalId = svg.id || "";
              const elementId = originalId.replace(/^barcode-/, "");

              const el = allElements.find(function (e) { return String(e.id) === String(elementId); });

              const resolvedValue = el
                ? self.resolveDynamicText(el.text, student, prn)
                : prn;

              const prnSafe = String(prn).replace(/\s+/g, "_").replace(/[^a-zA-Z0-9_\-]/g, "");
              const uniqSvgId = "barcode-" + prnSafe + "-" + sIndex + "-" + pIndex + "-" + (elementId || "x") + "-" + svgIndex;
              svg.id = uniqSvgId;

              svg.setAttribute("data-barcode-value", String(resolvedValue));
              svg.setAttribute("data-element-id", String(elementId || ""));

              svg.style.width = "100%";
              svg.style.height = "100%";

              const box = svg.parentElement;
              if (el && box) {
                box.style.position = "absolute";
                box.style.left = (el.left != null ? el.left : 0) + "mm";
                box.style.top = (el.top != null ? el.top : 0) + "mm";
                box.style.width = (el.width != null ? el.width : 10) + "mm";
                box.style.height = (el.height != null ? el.height : 10) + "mm";
                box.style.overflow = "hidden";
                if (el.bgColor) box.style.background = el.bgColor;
              }
            });

            page.querySelectorAll("div[id^='qr-']").forEach(function (qrDiv, qrIndex) {
              const originalId = qrDiv.id;
              const elementId = originalId.replace(/^qr-/, "");

              const el = allElements.find(function (e) { return String(e.id) === String(elementId); });
              if (!el) return;

              const resolvedValue = self.resolveDynamicText(el.text, student, prn);

              const prnSafe = String(prn)
                .replace(/\s+/g, "_")
                .replace(/[^a-zA-Z0-9_-]/g, "");

              qrDiv.id = "qr-" + prnSafe + "-" + sIndex + "-" + pIndex + "-" + elementId + "-" + qrIndex;

              qrDiv.setAttribute("data-qr-value", resolvedValue);
              qrDiv.setAttribute("data-qr-width", el.width);
              qrDiv.setAttribute("data-qr-height", el.height);
              qrDiv.setAttribute("data-qr-color", el.qrColor || "#000");
              qrDiv.setAttribute("data-qr-bg", el.bgColor || "#fff");
            });

            combinedHTML += '<div style="page-break-after:always;">' + page.outerHTML + "</div>";
          }
        }

        this.idcard_html = combinedHTML;
        this.renderIframePreview(combinedHTML);

        this.showSnackbar("green", "Icard/s fetched successfully");
      } catch (err) {
        console.error("getBatchIDCards error:", err);
        this.showSnackbar("red", "Error preparing bulk cards");
      } finally {
        this.fetch_loading = false;
      }
    },

    renderIframePreview(html) {
      const iframe = this.$refs.previewFrame;
      if (!iframe) return;

      const doc = iframe.contentDocument || iframe.contentWindow.document;
      doc.open();
      doc.write(html);
      doc.close();

      try {
        const style = doc.createElement("style");
        var frontCard = this.idcard_object && this.idcard_object.front && this.idcard_object.front.card
          ? this.idcard_object.front.card
          : {};
        const width = frontCard.width != null ? frontCard.width : 54;
        const height = frontCard.height != null ? frontCard.height : 86;
        style.innerHTML =
          ".page { width: " + width + "mm !important; height: " + height + "mm !important; position: relative; }" +
          "html, body { margin:0; padding:0; }";
        doc.head.appendChild(style);
      } catch (e) {
        console.error("preview style append error:", e);
      }

      var self = this;

      // load JsBarcode into iframe
      const js = doc.createElement("script");
      js.src = "https://cdn.jsdelivr.net/npm/jsbarcode@3.11.6/dist/JsBarcode.all.min.js";
      js.onload = function () {
        const iframeWin = doc.defaultView;
        try {
          var frontElements = (self.idcard_object && self.idcard_object.front && self.idcard_object.front.elements)
            ? self.idcard_object.front.elements : [];
          var backElements = (self.idcard_object && self.idcard_object.back && self.idcard_object.back.elements)
            ? self.idcard_object.back.elements : [];
          var allElements = frontElements.concat(backElements);

          doc.querySelectorAll("svg[id^='barcode-']").forEach(function (svg) {
            const value = svg.getAttribute("data-barcode-value") || "";
            const elementId = svg.getAttribute("data-element-id");
            const el = allElements.find(function (e) { return String(e.id) === String(elementId); });
            const cfg = {
              format: "CODE128",
              width: (el && el.barWidth != null) ? el.barWidth : 2,
              height: (el && el.barHeight != null) ? el.barHeight : ((el && el.height != null) ? el.height : 40),
              displayValue: (el && el.displayValue != null) ? el.displayValue : true,
              lineColor: (el && el.barColor) ? el.barColor : "#000",
              background: (el && el.bgColor) ? el.bgColor : "transparent",
              margin: 0,
            };
            try {
              iframeWin.JsBarcode(svg, value, cfg);
            } catch (err) {
              console.error("Preview JsBarcode error:", svg.id, err);
            }
          });
        } catch (err) {
          console.error("renderIframePreview error:", err);
        }
      };
      doc.head.appendChild(js);

      // QR preview render
      const qrjs = doc.createElement("script");
      qrjs.src = "https://cdn.jsdelivr.net/npm/qrcodejs@1.0.0/qrcode.min.js";
      qrjs.onload = function () {
        const DPI = self.getDPI();
        const mmToPx = function (mm) { return (mm / 25.4) * DPI; };

        doc.querySelectorAll("div[data-qr-value]").forEach(function (div) {
          const value = div.getAttribute("data-qr-value");
          if (!value) return;

          const w = Number(div.getAttribute("data-qr-width"));
          const h = Number(div.getAttribute("data-qr-height"));

          div.innerHTML = "";

          new doc.defaultView.QRCode(div, {
            text: value,
            width: Math.round(mmToPx(w)),
            height: Math.round(mmToPx(h)),
            useSVG: true,
            correctLevel: doc.defaultView.QRCode.CorrectLevel.H,
            colorDark: div.getAttribute("data-qr-color"),
            colorLight: div.getAttribute("data-qr-bg"),
          });
        });
      };
      doc.head.appendChild(qrjs);
    },

    printIDCard() {
      const iframeDoc =
        this.$refs.previewFrame.contentDocument ||
        this.$refs.previewFrame.contentWindow.document;
      if (!iframeDoc) {
        this.showSnackbar("red", "No preview to print");
        return;
      }

      const printWindow = window.open("", "_blank");
      if (!printWindow) {
        this.showSnackbar("red", "Popup blocked — allow popups");
        return;
      }

      printWindow.document.open();
      printWindow.document.write("<!DOCTYPE html>");
      printWindow.document.write(iframeDoc.documentElement.outerHTML);
      printWindow.document.close();

      const style = printWindow.document.createElement("style");
      var frontCard = this.idcard_object && this.idcard_object.front && this.idcard_object.front.card
        ? this.idcard_object.front.card
        : {};
      const width = frontCard.width != null ? frontCard.width : 54;
      const height = frontCard.height != null ? frontCard.height : 86;
      style.innerHTML =
        "@page { size: " + width + "mm " + height + "mm; margin: 0; }" +
        "html, body { width: " + width + "mm !important; height: " + height + "mm !important; margin:0; padding:0; }" +
        ".page { width: " + width + "mm !important; height: " + height + "mm !important; position: relative; page-break-after: always; }";
      printWindow.document.head.appendChild(style);

      var self = this;

      const js = printWindow.document.createElement("script");
      js.src = "https://cdn.jsdelivr.net/npm/jsbarcode@3.11.6/dist/JsBarcode.all.min.js";
      js.onload = function () {
        try {
          var frontElements = (self.idcard_object && self.idcard_object.front && self.idcard_object.front.elements)
            ? self.idcard_object.front.elements : [];
          var backElements = (self.idcard_object && self.idcard_object.back && self.idcard_object.back.elements)
            ? self.idcard_object.back.elements : [];
          var allElements = frontElements.concat(backElements);

          printWindow.document.querySelectorAll("svg[id^='barcode-']").forEach(function (svg) {
            const value = svg.getAttribute("data-barcode-value") || "";
            const elementId = svg.getAttribute("data-element-id");
            const el = allElements.find(function (e) { return String(e.id) === String(elementId); });
            const cfg = {
              format: "CODE128",
              width: (el && el.barWidth != null) ? el.barWidth : 2,
              height: (el && el.barHeight != null) ? el.barHeight : ((el && el.height != null) ? el.height : 40),
              displayValue: (el && el.displayValue != null) ? el.displayValue : true,
              lineColor: (el && el.barColor) ? el.barColor : "#000",
              background: (el && el.bgColor) ? el.bgColor : "transparent",
              margin: 0,
            };
            try {
              printWindow.JsBarcode(svg, value, cfg);
            } catch (err) {
              console.error("Print JsBarcode error:", svg.id, err);
            }
          });

          setTimeout(function () {
            printWindow.focus();
            printWindow.print();
            printWindow.close();
          }, 600);
        } catch (err) {
          console.error("Print flow error:", err);
          self.showSnackbar("red", "Print failed");
        }
      };
      printWindow.document.head.appendChild(js);

      const qrjs = printWindow.document.createElement("script");
      qrjs.src = "https://cdn.jsdelivr.net/npm/qrcodejs@1.0.0/qrcode.min.js";
      qrjs.onload = function () {
        const DPI = self.getDPI();
        const mmToPx = function (mm) { return (mm / 25.4) * DPI; };

        const qrDivs = printWindow.document.querySelectorAll("div[data-qr-value]");
        qrDivs.forEach(function (div) {
          const value = div.getAttribute("data-qr-value");
          if (!value) return;

          const w = Number(div.getAttribute("data-qr-width"));
          const h = Number(div.getAttribute("data-qr-height"));

          div.innerHTML = "";

          new printWindow.QRCode(div, {
            text: value,
            width: Math.round(mmToPx(w)),
            height: Math.round(mmToPx(h)),
            useSVG: true,
            correctLevel: printWindow.QRCode.CorrectLevel.H,
            colorDark: div.getAttribute("data-qr-color"),
            colorLight: div.getAttribute("data-qr-bg"),
          });
        });
      };
      printWindow.document.head.appendChild(qrjs);
    },

    getDPI() {
      const div = document.createElement("div");
      div.style.width = "1in";
      div.style.height = "1in";
      div.style.position = "absolute";
      div.style.top = "-100%";
      document.body.appendChild(div);
      const dpi = div.offsetWidth;
      document.body.removeChild(div);
      return dpi;
    },
  },
};
</script>

<style scoped>
/* no changes */
</style>